import { cn } from "@/lib/utils";
import { useGlitch } from "@/hooks/useGlitch";

const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&";
const LOWER = "abcdefghijklmnopqrstuvwxyz0123456789@#$%&";

function scrambleText(s: string): string {
  return Array.from(s, (c) => {
    if (/[A-Z]/.test(c)) return UPPER[Math.floor(Math.random() * UPPER.length)];
    if (/[a-z]/.test(c)) return LOWER[Math.floor(Math.random() * LOWER.length)];
    return c;
  }).join("");
}

interface GlitchTextProps {
  text: string;
  className?: string;
  minDelayMs?: number;
  maxDelayMs?: number;
}

/**
 * Inline text with a periodic chromatic-aberration glitch burst.
 * Renders a <span> with .glitch-text styling; case is preserved during scramble.
 */
export function GlitchText({ text, className, minDelayMs, maxDelayMs }: GlitchTextProps) {
  const { display, isGlitching } = useGlitch({
    target: text,
    enabled: true,
    scramble: scrambleText,
    minDelayMs,
    maxDelayMs,
  });

  return (
    <span
      className={cn("glitch-text", isGlitching && "glitch-text--active", className)}
      data-value={display}
    >
      {display}
    </span>
  );
}
